module.exports = __webpack_public_path__ + "img/xs.fb72e1d.jpg";